export default __webpack_public_path__ + "static/media/icon-pagination-last.5015e78a.svg";